import React from "react";

const ClearElementEditContext = React.createContext(()=>{})  

export default ClearElementEditContext